import React, { useState } from "react";
import { Edit, Edit2, Rss } from "lucide-react";
import { useEffect } from "react";
import { GETCUSTDET } from "../../api";

export default function Page() {
    
    const [details, setDetails] = useState({
        "_id": "666acf4951bcdec7de399775",
        "email": "email@123",
        "gst_no": "GSTNO",
        "phone": 1234567890,
        "firm_name": "NAME",
        "city": "CITY",
        "dl_no": "DLNO",
        "__v": 0
    });

    useEffect(() => {
        const id = JSON.parse(localStorage.getItem("userDetails")).userid;
        fetch(GETCUSTDET,{
            method:"POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({id:id})
        })
        .then((res) => {return res.json()})
        .then((res) => setDetails(res[0]));

    }, [])


    return (
        <main className="flex-1 p-4 sm:px-6 sm:py-0 md:gap-8">
            <div className="text-3xl font-bold">Profile</div>
            <div className="flex justify-between gap-14 my-4 px-6">
                <div className="w-full flex flex-col gap-6 pr-4">
                    <div className="flex flex-col font-medium text-lg">
                        <div className="flex justify-between">
                            Firm Name
                            <Edit2 className="w-4 h-4 text-slate-500" />
                        </div>
                        <text className="border-slate-400 border-[1px] rounded-md p-2 font-normal">{details.firm_name}</text>
                    </div>
                    <div className="flex flex-col font-medium text-lg">
                        <div className="flex justify-between">
                            Email
                            <Edit2 className="w-4 h-4 text-slate-500" />
                        </div>
                        <text className="border-slate-400 border-[1px] rounded-md p-2 font-normal">{details.email}</text>
                    </div>
                    <div className="flex flex-col font-medium text-lg">
                        <div className="flex justify-between">
                            Firm Address
                            <Edit2 className="w-4 h-4 text-slate-500" />
                        </div>
                        <text className="border-slate-400 border-[1px] rounded-md p-2 font-normal">{details.city}</text>
                    </div>
                    <div className="flex flex-col font-medium text-lg">
                        <div className="flex justify-between">
                            Contact Information
                            <Edit2 className="w-4 h-4 text-slate-500" />
                        </div>
                        <text className="border-slate-400 border-[1px] rounded-md p-2 font-normal">{details.phone}</text>
                    </div>
                    <div className="flex flex-col font-medium text-lg">
                        <div className="flex justify-between">
                            City
                            <Edit2 className="w-4 h-4 text-slate-500" />
                        </div>
                        <text className="border-slate-400 border-[1px] rounded-md p-2 font-normal">{details.city}</text>
                    </div>
                    <div className="flex flex-col font-medium text-lg">
                        <div className="flex justify-between">
                            GSTIN
                            <Edit2 className="w-4 h-4 text-slate-500" />
                        </div>
                        <text className="border-slate-400 border-[1px] rounded-md p-2 font-normal">{details.gst_no}</text>
                    </div>
                </div>
                <div className="min-w-fit flex flex-col items-center gap-4">
                    <img
                        src="https://images.pexels.com/photos/3683101/pexels-photo-3683101.jpeg?auto=compress&cs=tinysrgb&w=600"
                        alt="profile-photo"
                        className="w-36 h-36 object-cover rounded-full"
                    ></img>
                    <button className="flex font-semibold items-center gap-2 bg-primary text-white rounded-lg py-2 px-3">
                        Edit Photo
                        <Edit className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </main>
    );
}
